export default "__VITE_PUBLIC_ASSET__ccef9935__"